import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ObjetivoFlatNode, ObjetivoNode } from 'src/app/_dtos/ObjetivoNodeDTO';
@Component({
  selector: 'app-sidebar-objetivos',
  templateUrl: './sidebar-objetivos.component.html',
  styleUrls: ['./sidebar-objetivos.component.scss'],
  animations: [
    trigger('slideVertical', [
      state(
        '*',
        style({
          height: 0
        })
      ),
      state(
        'show',
        style({
          height: '*'
        })
      ),
      transition('* => *', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
    ])
  ]
})
export class SidebarObjetivosComponent implements OnInit {

  public dataSource: any;
  public treeNodo: any;
  public arbolObjetivos: any[];
  public nodoSeleccionado: any = {};

  constructor(
    public sharedService: SharedService,
    private restProvider: RestProviderService,
    private router: Router) {
  }

  ngOnInit(): void {
    if (this.sharedService.planSession)
      this.obtenerTodosLosObjetivosPorIDConfiguracionPlan();

    this.sharedService.updateSidebarObjetivos.subscribe(data => {
      if (data == "Update") {
        this.obtenerTodosLosObjetivosPorIDConfiguracionPlan()
      }
    });
  }

  public obtenerTodosLosObjetivosPorIDConfiguracionPlan() {
    let params = {
      data: {
        configuracionPlan: {
          id: this.sharedService.planSession.listaConfiguracionPlan[0].id
        }
      }
    }
    this.restProvider.executeHttpMethod("/oc/lohun", params).subscribe((result: any) => {
      this.arbolObjetivos = result.datalist;
      this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
      this.dataSource.data = result.datalist;
    });
  }


  treeControl = new FlatTreeControl<ObjetivoFlatNode>(
    node => node.level,
    node => node.expandable
  );


  private transformer = (node: ObjetivoNode, level: number) => {
    return {
      expandable: !!node.objetivosHijosList && node.objetivosHijosList.length > 0,
      nombre: node.nombre,
      descripcion: node.descripcion,
      avance: node.avance,
      count: node.count,
      fecMod: node.fecMod,
      configuracionPlan: node.configuracionPlan,
      objetivoPadre: node.objetivoPadre,
      level: level,
      id: node.id,
      expanded: false
    };
  };

  treeFlattener = new MatTreeFlattener(
    this.transformer,
    node => node.level,
    node => node.expandable,
    node => node.objetivosHijosList,
  );

  public irNivelSeleccionado(data) {
    data.expanded = !data.expanded;
    this.nodoSeleccionado = data;
    if (data.configuracionPlan) {
      if (data.configuracionPlan.nivel < this.sharedService.planSession.numeroNiveles - 1) {
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(["/objetivo/oc/", data.id], { skipLocationChange: true });
        });
      } else {
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(["/meta/mc/", data.id], { skipLocationChange: true });
        });
      }
    } else {
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        this.router.navigate(["avance/ac", data.id, this.sharedService.planSession.listaConfiguracionPlan[this.sharedService.planSession.listaConfiguracionPlan.length - 1].nombre], { skipLocationChange: true });
      });
    }
  }

  hasChild = (_: number, node: ObjetivoFlatNode) => node.expandable;

  public filtrarObjetivo(objetivo: string) {
    this.dataSource.data = this.arbolObjetivos;
    if (objetivo) {
      this.dataSource.data = this.filter(this.treeControl.dataNodes, objetivo.toLowerCase());
    }
  }


  public filter(array, text): any[] {
    const getNodes = (result, object) => {
      if ((object.nombre && object.nombre.toLowerCase().includes(text)) || (object.codigo && object.codigo.toLowerCase().includes(text))  || object.descripcion.toLowerCase().includes(text)) {
        result.push(object);
        return result;
      }
      if (Array.isArray(object.objetivosHijosList)) {
        const nodes = object.objetivosHijosList.reduce(getNodes, []);
        if (nodes.length) result.push({ ...object, nodes });
      }
      return result;
    };

    return array.reduce(getNodes, []);
  }
}
